<template>
  <div class="middle-panel">
    <div class="middle-panel-header">
      <div class="middle-panel-header-title">
        <span>CATEGORIES</span>
      </div>
      <div class="middle-panel-header-option">
        <b-button type="is-primary" outlined @click="addNewVotingCategory()">ADD CATEGORY</b-button>
        <span @click="closeCategoriesMobile">Close</span>
      </div>
    </div>
    <div class="middle-panel-body">
      <div class="voting-category-item" v-for="(item, index) in voting_categories" :key="index" :class="{
        active: selected_category && selected_category.id == item.id,
      }">
        <div class="voting-category-item-header">
          <div class="voting-category-title" @click="selectVotingCategory(item)">
            {{ item.prio }} - {{ item.name }}
          </div>
          <div class="voting-category-option">
            <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
              <template #trigger>
                <b-icon icon="dots-vertical"></b-icon>
              </template>
              <b-dropdown-item v-clipboard:copy="`${$store.state.SITE_BASE_URL}voting/${item.voting_session_id}/category/${item.slug}`
                " v-clipboard:success="onCopy" v-clipboard:error="onCopyError" aria-role="listitem">Get
                Link</b-dropdown-item>
              <b-dropdown-item @click="updateVotingCategory(item)" aria-role="listitem">Update</b-dropdown-item>
              <b-dropdown-item @click="deleteVotingCategory(item)" aria-role="listitem">Delete</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <div class="voting-category-item-footer" @click="selectVotingCategory(item)">
          <div class="voting-category-item-footer-left">
            <div class="voting-category-item-winner-number">
              Allowed winners: {{ item.winners_number }}
            </div>
          </div>
          <div class="voting-category-item-footer-right">
            <b-tag v-if="item.status == 'public'" type="is-success">Public</b-tag>
            <b-tag v-if="item.status == 'unlisted'" type="is-danger">Unlisted</b-tag>
          </div>
        </div>
      </div>
    </div>

    <!-- Add voting category modal -->
    <addNewVotingCategory v-if="show_addnew_categoy_modal" :session_id="session_id" :value="selected_category"
      @saved="onSaved" @close="show_addnew_categoy_modal = false">
    </addNewVotingCategory>
  </div>
</template>

<script>
import addNewVotingCategory from "../modals/addNewVotingCategory.vue";
export default {
  components: {
    addNewVotingCategory,
  },
  sockets: {},
  props: {
    session: {
      type: Object,
      default: () => { },
    },
  },
  computed: {
    session_id() {
      let vm = this;
      return vm.session.id;
    },
  },
  data: () => ({
    show_addnew_categoy_modal: false,
    selected_category: null,
    voting_categories: [],
    loading_voting_categories: false,
  }),
  watch: {
    session_id: function (val) {
      let vm = this;
      vm.getAllMyVotingCategories();
    },
  },
  mounted() {
    let vm = this;
    vm.getAllMyVotingCategories();
  },
  methods: {
    closeCategoriesMobile() {
      let vm = this;
      vm.$emit('close')
    },
    onCopy() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "Link copied to clipboard",
        type: "is-success",
      });
    },
    onCopyError() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "Failed to copy",
        type: "is-danger",
      });
    },
    selectVotingCategory(item) {
      let vm = this;
      vm.selected_category = item;
      vm.$emit("selected", item);
    },
    onSaved() {
      let vm = this;
      vm.show_addnew_categoy_modal = false;
      vm.getAllMyVotingCategories();
    },
    addNewVotingCategory() {
      let vm = this;
      vm.selected_category = null;
      vm.show_addnew_categoy_modal = true;
    },
    updateVotingCategory(item) {
      let vm = this;
      vm.selected_category = item;
      vm.show_addnew_categoy_modal = true;
    },
    deleteVotingCategory(item) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: "Deleting Voting Session",
        message:
          "Are you sure you want to <b>delete</b> this voting category? This action cannot be undone.",
        confirmText: "Delete Session",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          vm.$store
            .dispatch("VOTING_DELETE_MY_VOTING_CATEGORY", {
              id: item.id,
            })
            .then((response) => {
              vm.getAllMyVotingCategories();
              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
            })
            .catch(({ response }) => {
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: "Something went wrong, Contact your administrator",
              });
            });
        },
      });
    },
    getAllMyVotingCategories() {
      let vm = this;
      vm.loading_voting_categories = true;
      vm.$store
        .dispatch("VOTING_GET_ALL_MY_VOTING_CATEGORIES", {
          session_id: vm.session.id,
        })
        .then((response) => {
          vm.loading_voting_categories = false;
          vm.voting_categories = response.data.return.sort((a, b) =>
            a.prio > b.prio ? 1 : -1
          );
        })
        .catch(({ response }) => {
          vm.loading_voting_categories = false;
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OOPS!!!",
            text: "Something went wrong, Contact your administrator",
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.middle-panel {
  height: 100%;
  width: 400px;
  overflow-y: auto;
  border-left: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  @media (max-width: 592px) {
    position: absolute;
    background: white;
    z-index: 10;
    top: 60px;
    right: 0;
    width: 85%;
    box-shadow: -10px 10px 10px rgba(0, 0, 0, 0.089);
  }

  @media (max-width: 470px) {
    width: 96%;
  }

  .middle-panel-header {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    padding: 0px 10px;
    background: #fff;
    position: sticky;
    top: 0;

    .middle-panel-header-option {
      display: flex;
      align-items: center;

      span {
        display: none;
        margin-left: 10px;
        color: red;
        font-weight: 700;
        cursor: pointer;

        @media (max-width: 592px) {
          display: flex;
        }
      }
    }
  }

  .middle-panel-body {
    height: calc(100% - 60px);
    overflow-y: auto;

    .voting-category-item {
      width: 100%;
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid #ddd;
      cursor: pointer;

      &:hover {
        background: #fff;
      }

      &.active {
        background: #fff;
      }

      .voting-category-item-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;

        .voting-category-title {
          font-size: 14px;
          font-weight: 600;
          color: #333;
        }

        .voting-category-option {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .voting-category-item-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;

        .voting-category-item-footer-left {
          display: flex;
          align-items: center;
          justify-content: center;

          .voting-category-item-winner-number {
            font-size: 12px;
            color: #333;
          }
        }

        .voting-category-item-footer-right {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}
</style>